<!--{{data | json}}-->
@if (dataSignal()) {
    @if (!dataSignal()?.template) {
        <div class="tw-flex tw-column tw-snack-temp">
            @if (dataSignal()?.title) {
                <div class="tw-flex  tw-row title-snack border-left " style="justify-content: space-between;align-items: center;
    padding: 0.8rem;background: #262c38">
                    <div class="mat-h1" style="margin: 0">
                        {{ dataSignal()?.title }}
                    </div>
                    <button class="tw-snack-bt-temp" mat-flat-button color="primary" (click)="closeSnack()"> {{ 'title.OK' | translate }}</button>
                </div>
            }
            @if (dataSignal()?.message) {
                <div class="tw-margin-15 tw-flex tw-column snack-message-body-temp">
                    @for (msg of error(); track msg) {
                        @if (!msg.translate) {
                            <div class="snack-title-message-temp" [innerHTML]="msg.message"></div>
                        }
                        @if (msg.translate) {
                            <div class="snack-title-message-t-temp" [innerHTML]="msg.message  | translate"></div>
                        }
                    }
                </div>
            }
        </div>
    }

    @if (dataSignal()?.template === 1 && dataSignal()?.message) {
        <div class="tw-flex tw-column tw-snack-temp2">
            <div [ngClass]="snackBarClass()" class="tw-flex tw-row title-snack snack-message-body-temp" style="justify-content: space-between;align-items: center;
    padding: 0.8rem;background: #262c38">
                <div class=" tw-flex tw-column mat-body-2"
                     style="margin-bottom: 0;justify-items: center;align-items: center">

                    @for (msg of error(); track msg) {
                        @if (!msg.translate) {
                            <div class="snack-title-message-temp" [innerHTML]="msg.message"></div>
                        }
                        @if (msg.translate) {
                            <div class="snack-title-message-t-temp" [innerHTML]="msg.message  | translate"></div>
                        }
                    }


                </div>
                <div style="margin-left: 5px" class="snack-bt-temp">
                    <button mat-flat-button color="primary" (click)="closeSnack()"> {{ 'title.OK' | translate }}</button>
                </div>
            </div>
        </div>
    }
}
